var _jsxFileName = "/home/circleci/workspace/src/components/gallery.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 0;\n\tdisplay: block;\n\theight: auto;\n\tmax-width: 100%;\n\twidth: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tpadding-bottom: 0;\n\t\twidth: 40%;\n\t\t@media (max-width: 500px) {\n\t\t\tpadding-bottom: 0;\n\t\t}\n\t"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t\twidth: 30%;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tbox-sizing: border-box;\n\tdisplay: block;\n\tfloat: left;\n\tline-height: 0;\n\tpadding-right: ", ";\n\tpadding-bottom: ", ";\n\toverflow: hidden;\n\n\t", "\n\n\t", "\n\n\t@media (max-width: 500px) {\n\t\tpadding-right: ", ";\n\t\tpadding-bottom: ", ";\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: ", ";\n  overflow: hidden;\n  color: palevioletred;\n\n\t@media (max-width: 500px) {\n\t\tmargin-right: -", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Lightbox from 'react-images';
var gutter = {
  small: '2px',
  large: '4px'
};
var Base = styled.div(_templateObject(), gutter.small, gutter.large);
var Thumbnail = styled.a(_templateObject2(), gutter.small, gutter.small, function (props) {
  return props.landscape && css(_templateObject3());
}, function (props) {
  return props.square && css(_templateObject4());
}, gutter.large, gutter.large);
var Source = styled.img(_templateObject5());

var Gallery = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Gallery, _Component);

  function Gallery() {
    var _this;

    _this = _Component.call(this) || this;
    _this.state = {
      lightboxIsOpen: false,
      currentImage: 0
    };
    _this.closeLightbox = _this.closeLightbox.bind(_assertThisInitialized(_this));
    _this.gotoNext = _this.gotoNext.bind(_assertThisInitialized(_this));
    _this.gotoPrevious = _this.gotoPrevious.bind(_assertThisInitialized(_this));
    _this.gotoImage = _this.gotoImage.bind(_assertThisInitialized(_this));
    _this.handleClickImage = _this.handleClickImage.bind(_assertThisInitialized(_this));
    _this.openLightbox = _this.openLightbox.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = Gallery.prototype;

  _proto.openLightbox = function openLightbox(index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  };

  _proto.closeLightbox = function closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
  };

  _proto.gotoPrevious = function gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1
    });
  };

  _proto.gotoNext = function gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1
    });
  };

  _proto.gotoImage = function gotoImage(index) {
    this.setState({
      currentImage: index
    });
  };

  _proto.handleClickImage = function handleClickImage() {
    if (this.state.currentImage === this.props.images.length - 1) return;
    this.gotoNext();
  };

  _proto.renderGallery = function renderGallery() {
    var _this2 = this;

    var images = this.props.images;
    if (!images) return;
    var gallery = images.map(function (obj, i) {
      return /*#__PURE__*/React.createElement(Thumbnail, _extends({
        href: obj.src,
        key: i,
        onClick: function onClick(e) {
          return _this2.openLightbox(i, e);
        }
      }, obj.orientation, {
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 112,
          columnNumber: 5
        }
      }), /*#__PURE__*/React.createElement(Source, {
        src: obj.thumbnail,
        __self: _this2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 6
        }
      }));
    });
    return /*#__PURE__*/React.createElement(Base, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 4
      }
    }, gallery);
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: this.props.className,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 4
      }
    }, this.props.heading && /*#__PURE__*/React.createElement("h2", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 132,
        columnNumber: 28
      }
    }, this.props.heading), this.props.subheading && /*#__PURE__*/React.createElement("p", {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133,
        columnNumber: 31
      }
    }, this.props.subheading), this.renderGallery(), /*#__PURE__*/React.createElement(Lightbox, {
      currentImage: this.state.currentImage,
      images: this.props.images,
      isOpen: this.state.lightboxIsOpen,
      onClickImage: this.handleClickImage,
      onClickNext: this.gotoNext,
      onClickPrev: this.gotoPrevious,
      onClickThumbnail: this.gotoImage,
      onClose: this.closeLightbox,
      showThumbnails: this.props.showThumbnails,
      spinner: this.props.spinner,
      spinnerColor: this.props.spinnerColor,
      spinnerSize: this.props.spinnerSize,
      theme: this.props.theme,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 135,
        columnNumber: 5
      }
    }));
  };

  return Gallery;
}(Component);

Gallery.displayName = 'Gallery';
Gallery.propTypes = process.env.NODE_ENV !== "production" ? {
  heading: PropTypes.string,
  images: PropTypes.array,
  showThumbnails: PropTypes.bool,
  subheading: PropTypes.string
} : {};
export default Gallery;